import React from "react";

interface FinancingCoverageBarProps {
  coveragePct: number;
  coversInstallment: boolean;
  compact?: boolean;
}

export default function FinancingCoverageBar({
  coveragePct,
  coversInstallment,
  compact = false,
}: FinancingCoverageBarProps) {
  const normalizedCoverage = Math.min(100, Math.max(0, coveragePct));

  return (
    <div className="flex flex-col gap-1.5">
      <div className="flex items-center justify-between gap-2">
        <p className={`font-semibold uppercase tracking-wide text-[#6e7681] ${compact ? "text-[0.55rem]" : "text-[0.65rem]"}`}>
          Cobertura da parcela
        </p>
        <span className={`shrink-0 font-bold ${coversInstallment ? "text-[#3fb950]" : "text-[#f0f6fc]"} ${compact ? "text-[0.65rem]" : "text-xs"}`}>
          {normalizedCoverage.toFixed(0)}%
        </span>
      </div>
      <div className={`overflow-hidden rounded-full bg-white/[0.08] ${compact ? "h-1.5" : "h-2"}`}>
        <div
          className={`h-full rounded-full transition-all ${
            coversInstallment ? "bg-[#3fb950]" : "bg-[#6ea8ff]"
          }`}
          style={{ width: `${normalizedCoverage}%` }}
        />
      </div>
    </div>
  );
}
